import { createMqStyles, tokens } from '@fhs/ui';

export const useStoreCardMqStyles = createMqStyles({
  // Hairline lives on a child, not the Pressable: `borderBottomWidth` on Pressable
  // fights its inline `borderWidth` and shows up as a top/side border on web.
  card: {
    $base: {
      backgroundColor: tokens.colors.$white,
      // Clip Pressable's outline, which is positioned 4px outside the row.
      overflow: 'hidden',
    },
  },
  cardBody: {
    $base: {
      // Only ever separates the status badge from the details row.
      gap: 10,
      padding: 16,
    },
    $gteDesktop: {
      padding: 24,
    },
  },
  divider: {
    $base: {
      backgroundColor: tokens.colors.$blackOpacity10,
      height: 1,
    },
  },
  cardSelected: {
    $base: {
      backgroundColor: tokens.colors.$houseRedOpacity04,
    },
  },
  cardHovered: {
    $base: {
      backgroundColor: tokens.colors.$blackOpacity04,
    },
  },
  badge: {
    $base: {
      alignSelf: 'flex-start',
      borderRadius: 4,
      paddingHorizontal: 12,
      paddingVertical: 8,
    },
  },
  badgeWarning: {
    $base: {
      backgroundColor: tokens.colors.$warningBackground,
    },
  },
  badgeWarningText: {
    $base: {
      color: tokens.colors.$warning,
    },
  },
  badgeError: {
    $base: {
      backgroundColor: tokens.colors.$errorBackground,
    },
  },
  badgeErrorText: {
    $base: {
      color: tokens.colors.$error,
    },
  },
  // Both columns stretch so the icons sit against the top of the name and the CTA against
  // the bottom of the status line, rather than the pair floating in the vertical middle.
  bodyRow: {
    $base: {
      alignItems: 'stretch',
      flexDirection: 'row',
      gap: 4,
      justifyContent: 'space-between',
    },
  },
  selectRegion: {
    $base: {
      flexGrow: 1,
      flexShrink: 1,
      justifyContent: 'center',
    },
  },
  // The select region wraps its children in its own accessibility view, so the vertical
  // rhythm has to live on a container inside it rather than on `selectRegion`.
  selectRegionContent: {
    $base: {
      gap: 6,
    },
    $gteDesktop: {
      gap: 8,
    },
  },
  statusRow: {
    $base: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: 4,
    },
  },
  iconRow: {
    $base: {
      alignItems: 'center',
      flexDirection: 'row',
      flexShrink: 0,
      gap: 16,
      justifyContent: 'flex-end',
      pointerEvents: 'box-none',
    },
  },
  // Same box as the heart so swapping in the spinner cannot move the CTA.
  favoriteSlot: {
    $base: {
      alignItems: 'center',
      height: 20,
      justifyContent: 'center',
      overflow: 'hidden',
      width: 20,
    },
    $gteDesktop: {
      height: 22,
      width: 22,
    },
  },
  favoriteIconHidden: {
    $base: {
      opacity: 0,
    },
  },
  favoriteOutlineHidden: {
    $base: {
      borderColor: tokens.colors.$transparent,
    },
  },
  favoriteSpinner: {
    $base: {
      alignItems: 'center',
      bottom: 0,
      justifyContent: 'center',
      left: 0,
      position: 'absolute',
      right: 0,
      top: 0,
    },
  },
  // Empty space in this column clicks through to the card so the whole row selects.
  // zIndex keeps the favourite / info / CTA above Pressable's outline overlay.
  ctaColumn: {
    $base: {
      alignItems: 'flex-end',
      flexShrink: 0,
      justifyContent: 'space-between',
      pointerEvents: 'box-none',
      zIndex: 1,
    },
  },
  ctaBlocked: {
    $base: {
      pointerEvents: 'none',
    },
  },
});
